var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9865 19.4323C8.06947 19.4323 4.14267 17.0972 0.314398 12.4918C0.0709819 12.1989 0.0709819 11.7742 0.314398 11.4813C4.14267 6.87613 8.06947 4.54102 11.9865 4.54102C15.9033 4.54102 19.8304 6.87613 23.6586 11.4813C23.9023 11.7742 23.9023 12.1989 23.6586 12.4918C19.8304 17.097 15.9033 19.4323 11.9865 19.4323ZM1.95851 11.9865C5.32946 15.8791 8.70093 17.8517 11.9865 17.8517C15.2724 17.8517 18.6436 15.8794 22.0145 11.9865C18.6436 8.094 15.2724 6.12164 11.9865 6.12164C8.70093 6.12164 5.32946 8.094 1.95851 11.9865Z",
    fill: "#9F9F9F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.987 15.6747C14.0238 15.6747 15.6751 14.0234 15.6751 11.9865C15.6751 9.94963 14.0238 8.2984 11.987 8.2984C9.95006 8.2984 8.29883 9.94963 8.29883 11.9865C8.29883 14.0234 9.95006 15.6747 11.987 15.6747Z",
    fill: "#9F9F9F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.e1e09de84e05838bfd6e2b7e792f1cbe.svg";
export { ForwardRef as ReactComponent };